

class Map {

	constructor (mapdata){
		this.data = {};
		if(mapdata) this.load(mapdata);
	}

	load (mapdata){
		_.each(mapdata, (data, category) => {
			if(! this.data[category]) this.data[category] = {};
			Array.from(data.zen).map((z,i) => {
				this.data[category][z.charCodeAt(0)] = data.han.charCodeAt(i);
			});
		});
	}

	map (options){
		var map = {};
		_.each(options, (value, key) => {
			if(! value || ! this.data[key]) return;
			_.extend(map, this.data[key]);
		});
		return map;
	}

}



const map = new Map({
	"number": {
		zen: "０１２３４５６７８９",
		han: "0123456789"
	},
	"alphabet": {
		zen: "ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ",
		han: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
	},
	"space": {
		zen: "　",
		han: " "
	},
	"symbol": {
		zen: "！”＃＄％＆’（）＝〜｜｀｛＋＊｝＜＞？＿ー＾￥＠「；：」、。／",
		han: "!\"#$%&'()=~|`{+*}<>?_-^\\@[;:],./"
	}

});


export default map;



// WEBPACK FOOTER //
// ./src/js/lib/zen2han.map.js